import { render, staticRenderFns } from "./DealerStatusTambah.vue?vue&type=template&id=42b093b1&scoped=true&"
import script from "./DealerStatusTambah.vue?vue&type=script&lang=js&"
export * from "./DealerStatusTambah.vue?vue&type=script&lang=js&"
import style0 from "./DealerStatusTambah.vue?vue&type=style&index=0&id=42b093b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b093b1",
  null
  
)

export default component.exports